import {
  LIST_INSURANCES,
  CREATE_INSURANCE,
  UPDATE_INSURANCE,
} from '@/data/actions/modules/general';

export default [
  {
    path: '/clinical/insurance-plans',
    component: () => import(/* webpackChunkName: "insurances" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_INSURANCES,
    },
  },
  {
    path: '/clinical/insurance-plans/create',
    component: () => import(/* webpackChunkName: "insurances" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_INSURANCE,
    },
  },
  {
    path: '/clinical/insurances/:insuranceId/plans/:id/edit',
    component: () => import(/* webpackChunkName: "insurances" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: UPDATE_INSURANCE,
    },
  },
];
